import { useContext } from 'react';
import { ReactRelayContext } from 'react-relay';

export function useSafeRelayEnvironment() {
  const context = useContext(ReactRelayContext);
  return context?.environment;
}
